//@ts-check

// @ts-ignore
let config = process.env;

/**
 * @description Represents the appLinkSettings type
 *
 * @typedef {Object} appLinkSettingsType
 * @property {string|undefined} env
 * @property {string|undefined} OIDC_PROVIDER
 * @property {string|undefined} OIDC_CLIENT_ID
 * @property {string|undefined} OIDC_REDIRECT_ROUTE
 * @property {string|undefined} OIDC_END_SESSION_ENDPOINT
 * @property {string|undefined} APIM_BASE_URL
 * @property {string|undefined} APIM_KEY
 * @property {string|undefined} APPINSIGHTS_CONNECTIONSTRING
 * @property {string|undefined} BUILD_VERSION
 * @property {string|undefined} BUILD_DATE
 */

/**
 * @description appSettings.json is the repo to access the env. variable. Based on the env. variable it
 * will produce the required appSettings configuration.
 *
 * @type {appLinkSettingsType}
 */
let appSettingsMutable = {
  env: "",
  OIDC_PROVIDER: "",
  OIDC_CLIENT_ID: "",
  OIDC_REDIRECT_ROUTE: "",
  OIDC_END_SESSION_ENDPOINT: "",
  APIM_BASE_URL:"",
  APIM_KEY:"",
  APPINSIGHTS_CONNECTIONSTRING:"",
  BUILD_VERSION: config.REACT_APP_BUILD_VERSION || "local",
  BUILD_DATE: config.REACT_APP_BUILD_DATE || new Date().toLocaleString(),
};

// DEV
if (config.REACT_APP_ENV === "DEV") {
  appSettingsMutable = {
    env: config.REACT_APP_ENV,
    OIDC_PROVIDER: config.REACT_APP_DEV_OIDC_PROVIDER,
    OIDC_CLIENT_ID: config.REACT_APP_DEV_OIDC_CLIENT_ID,
    OIDC_REDIRECT_ROUTE: config.REACT_APP_DEV_OIDC_REDIRECT_ROUTE,
    OIDC_END_SESSION_ENDPOINT: config.REACT_APP_DEV_OIDC_END_SESSION_ENDPOINT,
    APIM_BASE_URL:config.REACT_APP_DEV_PAYLOADESTIMATES_APIM_BASE_URL,
    APIM_KEY:config.REACT_APP_DEV_PAYLOADESTIMATES_APIM_KEY,
    APPINSIGHTS_CONNECTIONSTRING:config.REACT_APP_DEV_APPINSIGHTS_CONNECTIONSTRING,
    BUILD_VERSION: config.REACT_APP_BUILD_VERSION || "local",
    BUILD_DATE: config.REACT_APP_BUILD_DATE || new Date().toLocaleString(),
  };
}

// TEST
else if (config.REACT_APP_ENV === "TEST") {
  appSettingsMutable = {
    env: config.REACT_APP_ENV,
    OIDC_PROVIDER: config.REACT_APP_TEST_OIDC_PROVIDER,
    OIDC_CLIENT_ID: config.REACT_APP_TEST_OIDC_CLIENT_ID,
    OIDC_REDIRECT_ROUTE: config.REACT_APP_TEST_OIDC_REDIRECT_ROUTE,
    OIDC_END_SESSION_ENDPOINT: config.REACT_APP_TEST_OIDC_END_SESSION_ENDPOINT,
    APIM_BASE_URL:config.REACT_APP_TEST_PAYLOADESTIMATES_APIM_BASE_URL,
    APIM_KEY:config.REACT_APP_TEST_PAYLOADESTIMATES_APIM_KEY,
    APPINSIGHTS_CONNECTIONSTRING:config.REACT_APP_TEST_APPINSIGHTS_CONNECTIONSTRING,
    BUILD_VERSION: config.REACT_APP_BUILD_VERSION || "local",
    BUILD_DATE: config.REACT_APP_BUILD_DATE || new Date().toLocaleString(),
  };
}

// QA
else if (config.REACT_APP_ENV === "QA") {
  appSettingsMutable = {
    env: config.REACT_APP_ENV,
    OIDC_PROVIDER: config.REACT_APP_QA_OIDC_PROVIDER,
    OIDC_CLIENT_ID: config.REACT_APP_QA_OIDC_CLIENT_ID,
    OIDC_REDIRECT_ROUTE: config.REACT_APP_QA_OIDC_REDIRECT_ROUTE,
    OIDC_END_SESSION_ENDPOINT: config.REACT_APP_QA_OIDC_END_SESSION_ENDPOINT,
    APIM_BASE_URL:config.REACT_APP_QA_PAYLOADESTIMATES_APIM_BASE_URL,
    APIM_KEY:config.REACT_APP_QA_PAYLOADESTIMATES_APIM_KEY,
    APPINSIGHTS_CONNECTIONSTRING:config.REACT_APP_QA_APPINSIGHTS_CONNECTIONSTRING,
    BUILD_VERSION: config.REACT_APP_BUILD_VERSION || "local",
    BUILD_DATE: config.REACT_APP_BUILD_DATE || new Date().toLocaleString(),
  };
}

// PROD
else if (config.REACT_APP_ENV === "PROD") {
  appSettingsMutable = {
    env: config.REACT_APP_ENV,
    OIDC_PROVIDER: config.REACT_APP_PROD_OIDC_PROVIDER,
    OIDC_CLIENT_ID: config.REACT_APP_PROD_OIDC_CLIENT_ID,
    OIDC_REDIRECT_ROUTE: config.REACT_APP_PROD_OIDC_REDIRECT_ROUTE,
    OIDC_END_SESSION_ENDPOINT: config.REACT_APP_PROD_OIDC_END_SESSION_ENDPOINT,
    APIM_BASE_URL:config.REACT_APP_PROD_PAYLOADESTIMATES_APIM_BASE_URL,
    APIM_KEY:config.REACT_APP_PROD_PAYLOADESTIMATES_APIM_KEY,
    APPINSIGHTS_CONNECTIONSTRING:config.REACT_APP_PROD_APPINSIGHTS_CONNECTIONSTRING,
    BUILD_VERSION: config.REACT_APP_BUILD_VERSION || "local",
    BUILD_DATE: config.REACT_APP_BUILD_DATE || new Date().toLocaleString(),
  };
}

const appSettings = appSettingsMutable;
export { appSettings };
